export const blue = {
  50: '#304ffe',
  75: 'rgba(230, 240, 255, 0.5)',
  100: '#E6F0FF',
  200: '#0066FF',
  300: '#0052CC',
  400: '#030086',
  500: '#5f25a4',
  600: '#050449',
};

export const green = {
  100: '#E5F3E5',
  200: '#008800',
  300: '#006D00',
};

export const yellow = {
  100: '#FCF3E4',
  200: '#F7C145',
  300: '#A57E26',
};

export const red = {
  100: '#FFE6EB',
  200: '#FC0834',
  300: '#D9052C',
};

export const orange = {
  100: '#fae7d1',
  200: '#F3993E',
  300: '#5c3311',
};

export const neutral = {
  100: '#FFFFFF',
  150: '#FAFAFA',
  200: '#EBEDF1',
  300: '#AAAAAA',
  400: '#888888',
  500: '#444444',
  600: '#000000',
};

export const purple = {
  100: '#e5d1fa',
  300: '#33175d',
};

export const pink = {
  100: '#f8d1e6',
  300: '#5c1433',
};

export const gray = {
  100: '#bdbdbd',
  200: '#3a3a3a',
  300: '#909090',
  400: '#AEAEAE',
};
